import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { UserModel } from '../../../models/user/userModel';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import { Checkbox } from 'primereact/checkbox';
import { PushNotificationSubscription } from "../../../models/pushNotificationSubscription";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import * as Constants from '../../../common/constants';

interface IProps {
  history: any,
  onCancelClick: any;
}

interface IState {
  isLoading: boolean;
  user: UserModel;
}

class UserAccountTab extends React.Component<IProps, IState> {

  userService = new UserService();
  authService = new AuthService();
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      user: new UserModel()
    };
  }

  componentDidMount() {
    this.getUserData();
  }

  getUserData() {
    if (this.authService.isAuthenticated()) {

      this.setState({
        isLoading: true
      });

      let id = this.authService.getUserId();

      this.userService.getUser().then(
        (data: any) => {
          if (data) {
            this.setState({
              isLoading: false,
              user: data
            });
          }
        })
        .catch(error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  }

  handleChange = (key, value) => {
    const user: UserModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  handleSaveButton = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    this.setState({
      isLoading: true
    });

    const user = this.state.user;

    this.userService.updateUser(user).then(
      (data: any) => {
        if (data) {
          this.setState({
            isLoading: false
          });
          this.growl.show({ severity: 'success', summary: Translate('You have successfully saved your data.') });
        }
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });

  }

  isValidAddEditForm() {
    let message = '';

    const { user } = this.state;

    if (!user.email || user.email.trim() == '') {
      message += Translate('Please enter Email');
    } else {
      if (!HelperFunctions.validateEmail(this.state.user.email)) {
        message += Translate('Please enter valid Email');
      }
    }

    if (!user.name || user.name.trim() == '') {
      message += Translate('Please enter Name');
    }

    message ? this.growl.show({ severity: 'error', summary: message }) : null;

    return message == '';
  }

  public render() {
    const { isLoading, user } = this.state;

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        <Growl ref={(el) => this.growl = el} />

        <div>
          <div>

            <div className="p-g p-fluid">
              <div className="p-g-12 p-md-12">
                <TextField
                  name="email"
                  label={Translate('Email')}
                  type="email"
                  value={user && user.email ? user.email : ""}
                  onChange={(e) => this.handleChange('email', e.target['value'])}
                />
              </div>
              <div className="p-g-12 p-md-12">
                <TextField
                  autoComplete="off"
                  name="name"
                  label={Translate('Name')}
                  type="text"
                  value={user && user.name ? user.name : ""}
                  onChange={(e) => this.handleChange('name', e.target['value'])}
                />
              </div>
            </div>
            <div style={{ textAlign: 'right', padding: '10px 9px' }}>
              <Button variant="contained" size="small" onClick={this.props.onCancelClick} style={{ marginRight: '10px' }}>
                <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                {Translate('Cancel')}
              </Button>
              <Button variant="contained" size="small" color="primary" onClick={this.handleSaveButton}>
                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                {Translate('Save')}
              </Button>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

export default UserAccountTab;